import {useNavigation, StackActions} from '@react-navigation/native';
import * as React from 'react';
import {View, Text} from 'react-native';
import {images} from '../../../../assets/icons';
import {Button} from '../../../../shared/components/button';
import {useStyles} from '../../../../shared/hooks/styles';
import {useTheme} from '../../../../shared/theme';
import {DeviceSize, useDeviceSize} from '../../../../shared/theme/helpers';
import {LoginLayout} from '../../components/layout';
import {Screens} from '../../../../shared/routing';

interface ConfirmationInvalidLinkProps {
  message: string;
}

export const ConfirmationInvalidLink: React.FC<ConfirmationInvalidLinkProps> = ({message}) => {
  const navigation = useNavigation();
  const deviceSize = useDeviceSize();
  const theme = useTheme();
  const styles = useStyles(({mediaOnly}) => ({
    topImageContainer: {
      ...mediaOnly(
        DeviceSize.mobile,
        {width: 64, height: 64, marginBottom: -40},
        {width: 90, height: 90, marginBottom: -20},
      ),
      borderRadius: 45,
      borderWidth: 2,
      borderColor: theme.input.common.errorColor,
      justifyContent: 'center',
      alignItems: 'center',
    },
    container: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: 50,
    },
    message: {},
    messageTitle: {
      ...mediaOnly(DeviceSize.mobile, theme.fonts.body, theme.fonts.h5Light),
      color: theme.input.common.errorColor,
      marginBottom: 5,
      textAlign: 'center',
    },
    messageDescription: {
      ...mediaOnly(DeviceSize.mobile, theme.fonts.bodySmallLight, theme.fonts.body),
      color: theme.color.labelText,
    },
    button: {
      width: '100%',
      ...mediaOnly(DeviceSize.mobile, {maxWidth: 200}, {maxWidth: 303}),
    },
  }));
  const topImageProps = {
    width: deviceSize === DeviceSize.mobile ? 24 : 30,
    height: deviceSize === DeviceSize.mobile ? 24 : 30,
    color: theme.input.common.errorColor,
  };

  return (
    <LoginLayout
      title='Восстановление пароля'
      topImage={
        <View style={styles.topImageContainer}>
          <images.Close {...topImageProps} />
        </View>
      }
      containerStyle={styles.container}>
      <View style={styles.message}>
        <Text style={styles.messageTitle}>Ссылка недействительна.</Text>
        <Text style={styles.messageDescription}>{message}</Text>
      </View>
      <Button
        id='invalid-link-return'
        type='primary'
        text='На главную'
        style={styles.button}
        onPress={() => navigation.dispatch(StackActions.replace(Screens.Login))}
      />
    </LoginLayout>
  );
};
